import React from 'react';

// RegistrationOption component to display registration types and benefits
const RegistrationOption = ({ title, price, benefits, isButtonVisible }) => (
  <div className="mb-8 p-4 shadow-lg rounded-lg bg-white">
    <h3 className="text-xl font-bold text-blue-900">{title} - ${price}</h3>
    <ul className="list-disc list-inside text-gray-700">
      {benefits.map((benefit, index) => (
        <li key={index}>{benefit}</li>
      ))}
    </ul>
    {isButtonVisible && (
      <a href="https://pay.uow.edu.au/InternationalConferenceonAdvancedManufacturing" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
        <button style={{ padding: '10px 20px', margin: '10px', backgroundColor: 'blue', color: 'white', border: 'none', borderRadius: '5px', cursor: 'pointer' }}>
          Register Now
        </button>
      </a>
    )}
  </div>
);

// Registration component definition
const Registration = () => {
  return (
    <div className="container mx-auto px-4">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <RegistrationOption 
          title="Full Registration (early bird due 31 August 2025)"
          price="1280"
          benefits={["Conference proceedings", "Conference gift bag", "Welcome dinner"]}
          isButtonVisible={true}
        />
        <RegistrationOption 
          title="Student Registration (early bird due 31 August 2025)"
          price="780"
          benefits={["Conference proceedings", "Conference gift bag", "Welcome dinner"]}
          isButtonVisible={true}
        />
        <RegistrationOption 
          title="Full Registration"
          price="1380"
          benefits={["Conference proceedings", "Conference gift bag", "Welcome dinner", "Additional workshops and seminars"]}
          isButtonVisible={false}
        />
        <RegistrationOption 
          title="Student Registration"
          price="880"
          benefits={["Conference proceedings", "Conference gift bag", "Welcome dinner", "Access to student networking events"]}
          isButtonVisible={false}
        />
      </div>
    </div>
  );
};

export default Registration;